module.exports = "/_next/static/images/mendu-fb8ea3b2150fcfdea669bc4dd5fbe927.png";